import {Component, Input, OnChanges, SimpleChanges, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-communicate-container',
  templateUrl: './communicate-container.component.html',
  styleUrls: ['./communicate-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommunicateContainerComponent implements OnChanges {
  @Input() formData: any;
  @Input() isSafeHtml: boolean = false;
  @Input() isScrollIntoView: boolean = false;
  @Input() scrollOffset: number = -108;
  showLongCommunicate = false;
  komunikat = {
    tresc: '',
    tytul: '',
    podtytul: '',
    typ: '',
    ikona: ''
  };

  public uid = 'cc'+Math.floor(Math.random()*new Date().getTime());

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formData?.currentValue) {
      const item = changes.formData.currentValue;
      this.komunikat.tytul = this.replace(this.isSafeHtml, item.tytul);
      this.komunikat.podtytul = this.replace(this.isSafeHtml, item.podtytul);
      this.komunikat.tresc = this.replace(this.isSafeHtml, item.tresc);
      this.komunikat.typ = item.typ || 'info';
      this.showLongCommunicate = !(item.pokazWiecej || false);

      switch (this.komunikat.typ) {
        case 'info':
          this.komunikat.ikona = 'pi pi-info-circle'; break;
        case 'success':
          this.komunikat.ikona = 'pi pi-check'; break;
        case 'warning':
          this.komunikat.ikona = 'pi pi-exclamation-triangle'; break;
        case 'error':
          this.komunikat.ikona = 'pi pi-times-circle'; break;
      }
    }
  }

  showHideCommunicate() {
    this.showLongCommunicate = !this.showLongCommunicate;
    if(this.isScrollIntoView) {
      const ele = document.getElementById(this.uid);
      if(ele) {
        window.scrollBy(0, ele.getBoundingClientRect().y + this.scrollOffset);
      }
    }
  }

  private replace(isSafeHtml: boolean, value: string | null): string {
    if(isSafeHtml) {
      return value || '';
    }
    return value ? value.replace(/<p>/gi, '').replace(/<\/p>/gi, '<br>') : '';
  }

}
